import React from 'react';
import { Modal, Button } from 'antd';

import { _success, _setAxios, _warn } from '../../../../../lib/Helper';
import { InfoCircleOutlined } from '@ant-design/icons';

class ConfirmTambahAnggota extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        };
    }

    handleSubmit = () => {
        const { data } = this.props
        if(!data.ekstrakurikuler_id) {
            _warn('topRight', 'Warning', 'Pilih ekstrakurikuler terlebih dahulu');
            return
        }
        
        this.setState({
            loading: true
        });

        let payload = {
            "ekstrakurikuler_id": data.ekstrakurikuler_id,
            "siswa": []
        }

        data?.siswa?.forEach(rows => {
            let row = rows.split('-')
            let siswaId = row[0]
            let rombelId = row[1]
            payload.siswa.push({
                siswa_id: siswaId,
                rombel_id: rombelId
            })
        });

        let ekstrakurikuler_id = data.ekstrakurikuler_id

        _setAxios("kaldik-kegiatan/ekstrakurikuler/anggota", "POST", payload).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                setTimeout(function () {
                    window.location.href = '/ekstrakurikuler-pramuka/ekstrakurikuler/detail/' + ekstrakurikuler_id;
                }, 1000);
            } else {
                this.setState({
                    loading: false
                });
            }
        })
    };

    render() {

        return (
            <Modal
                maskClosable={false}
                title={<><InfoCircleOutlined /> Konfirmasi</>}
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                width={300}
                footer={<>
                    <Button onClick={this.props.hideModal}>Batal</Button>
                    <Button type="primary" htmlType="submit" onClick={this.handleSubmit} loading={this.state.loading}>Simpan</Button>
                </>}
            >
                Data akan ditrambahkan ke ekstrakurikuler, Apakah Anda Yakin?
            </Modal>
        )
    }
}

export default ConfirmTambahAnggota;
